import React from 'react';
import '../../styles/App.css'; // Ensure this path is correct

interface ErrorBubbleProps {
  message: string | null;
  type?: 'error' | 'success'; // Add a type prop
}

const ErrorBubble: React.FC<ErrorBubbleProps> = ({ message, type = 'error' }) => {
  if (!message) return null;

  return (
    <div className={`error-bubble ${type}`}>
      {message}
    </div>
  );
};

export default ErrorBubble;